module.exports = __webpack_public_path__ + "img/soporte.7a1b2056.png";